module.exports = __webpack_public_path__ + "img/logo.a452cfb6.png";